import { useAdoptedTools } from "../../../marketplace";
import { PendingPaymentsCard } from "../../../payments";

/**
 * Shows what is still owed on the home page, but only for therapists who have
 * adopted Payments.
 *
 * The adoption check lives here rather than inside the card — the same split
 * `HomeNextSession` uses for the Scheduler — so the card stays a plain
 * presentation of payments data, and its queries never run for a therapist
 * without the tool. Without this the list request would 403 on every home page
 * load for everyone else.
 */
export default function HomePendingPayments() {
    const { data: tools, isLoading } = useAdoptedTools();

    if (isLoading || !tools) return null;
    if (!tools.some((tool) => tool.slug === "payments")) return null;

    return <PendingPaymentsCard />;
}
